import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import assign from 'lodash.assign'

import { Link as ReactRouterLink } from 'react-router'

import { addTrackingParams } from '../../utils/tracking'

const snipsSubDomainRegExp = new RegExp(/^https:\/\/[^.]*\.snips.ai/)

const Link = props => {
  const useAnchor =
    props.forceAnchorElement ||
    (props.target && props.target === '_blank') ||
    props.download
  // in the last react version, the a throws a warning
  // if we pass props that does not belong to its
  // propTypes definition. We need here to remove forceAnchorElement
  const linkProps = assign({}, props, {
    className: props.className ? props.className + ' ' : '' + 'link',
    // NOTE SURE why the ``|| undefined` is needed for target
    // without it, the value `false` triggers windows to open in new tabs..
    target: props.target || undefined
  })
  delete linkProps.forceAnchorElement
  delete linkProps.dispatch

  const LinkComponent = useAnchor ? 'a' : ReactRouterLink
  return <LinkComponent {...linkProps} to={props.href} />
}

Link.propTypes = {
  download: PropTypes.bool,
  forceAnchorElement: PropTypes.bool, // use anchor, so no client side routing
  href: PropTypes.string.isRequired,
  target: PropTypes.string
}

// NOTE: if it's a link to another snips subdomain,
// rewrite the href: adding a mxd query param, for mixpanel sdk tracking.
// Note: reading mxd from tracking reducer in order to detect change (on mount after server render)
// -- don't remove! (addTrackingParams resolves the mxd itself)
const mapStateToProps = ({ tracking: { mxd } }, { href }) => {
  if (href && snipsSubDomainRegExp.test(href)) {
    return {
      href: addTrackingParams(href)
    }
  }
  return {}
}

export default connect(mapStateToProps)(Link)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Link.js